module.exports = __webpack_public_path__ + "static/media/rightts.2e377927.png";